import { render, staticRenderFns } from "./DrawTasks.vue?vue&type=template&id=a4c0ae00&scoped=true"
import script from "./DrawTasks.vue?vue&type=script&lang=js"
export * from "./DrawTasks.vue?vue&type=script&lang=js"
import style0 from "./DrawTasks.vue?vue&type=style&index=0&id=a4c0ae00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c0ae00",
  null
  
)

export default component.exports